export default __webpack_public_path__ + "static/media/Let_sSync.320d61be.webp";